import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import { formatDate } from '../lib/time'
import './Tables.css'
import { InfoTip } from './InfoTip'
import { Link } from 'react-router-dom'

export function ActiveEngagements() {
  const { data, isPending, isError } = useQuery({
    queryKey: ['active-engagements'],
    queryFn: () => api.getActiveEngagements(),
  })

  return (
    <section className="card sec" style={{ padding: '18px 0 6px' }}>
      <h2 className="h2" style={{ padding: '0 20px' }}>Active Conversations &amp; Interviews <InfoTip tip="engagements" /></h2>

      {isPending && <div className="rc-msg" aria-busy="true">Loading engagements…</div>}
      {isError && <div className="rc-msg" role="alert"><b>Could not load engagements</b></div>}
      {data && data.items.length === 0 && (
        <div className="rc-msg">
          <b>No open conversations</b>
          Engagements appear here once a conversation or interview stage is open.
        </div>
      )}

      {data && data.items.length > 0 && (
        <div className="tw" style={{ marginTop: 6 }}>
          <table className="t">
            <thead>
              <tr>
                <th>Executive (Profile ID)</th><th>Pipeline</th><th>Current Stage</th>
                <th>Last Activity</th><th>Owner</th><th>Next Action</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((e) => (
                <tr key={e.id}>
                  <td>
                    <span className="nm">{e.executive_display_name}</span>{' '}
                    <span className="pid">({e.executive_reference_code})</span>
                  </td>
                  <td>{e.pipeline_name}</td>
                  <td>{e.stage_label}</td>
                  <td>{e.last_activity_on ? formatDate(e.last_activity_on) : '—'}</td>
                  <td>{e.owner_name}</td>
                  <td><Link className="btn btn-sm" to={e.next_action_url}>{e.next_action_label}</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
